import type { BoxProps, ImageProps } from "@chakra-ui/react";
import { contentStyles } from "modules/storyblok/adapters/Content";
import type { RichtextAdapterProps } from "modules/storyblok/adapters/RichtextAdapter";

const imageStyles: ImageProps = {
  w: "full",
  borderRadius: "xl",
  objectFit: { md: "scale-down", lg: "cover" },
};

const boxStyles: BoxProps = {
  pos: "absolute",
  top: { base: "90%", lg: "50%" },
  right: { base: "40.5%", md: "33%", lg: "0" },
  bg: "white",
  borderRadius: "md",
  p: 8,
  transform: "translate(40%, -50%)",
  boxShadow: "alt",
  minW: { base: "84vw", lg: "auto" },
  textAlign: "left",
};

const imageCreditStyles: RichtextAdapterProps["customStyles"] = {
  ...contentStyles,
  link: { fontSize: "sm", color: "greyscale.600", fontWeight: "normal", _hover: { color: "primary.500" } },
  paragraph: { ...contentStyles.paragraph, fontSize: "sm", color: "greyscale.500" },
};

export { imageStyles, boxStyles, imageCreditStyles };
